import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { flash } from '../../toastConfig';

import './styles.css';

const ContactForm = (props) => {

    const formInitialState = {};
    const formFields = [
        'name',
        'email',
        'message',
    ];

    formFields.forEach((field) => {
        formInitialState[field] = '';
    });

    const [formData, setFormData] = useState(formInitialState);

    const [errors, setErrors] = useState({});

    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name] : value
        }));
    };

    useEffect(() => {
        if (Object.keys(errors).length > 0) {
            const firstErrorField = Object.keys(errors)[0];
            
            const elementToFocus = document.querySelector(`form [name="${firstErrorField}"]`);
            if (elementToFocus) {
                elementToFocus.focus();
            }
        }
    }, [errors]);

async function handleSubmit(e){
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
        const axiosResponse = await axios({
            method: 'post',
            url: 'submit-inquiry',
            data: formData,
            headers: { 
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        });

        if (axiosResponse.status !== 200) {
            throw new Error('Network response was not ok');
        }

        let response = axiosResponse.data;

        if (response.status === true) {
            setErrors({});
            flash('success', response.data.msg);
            setFormData(formInitialState);
        }else{
            setErrors(response.data);
        }

    }catch{
        flash('error', 'Some Errors Found');
    }
    setIsSubmitting(false);
};

return (
    <React.Fragment>
        <div className="container">
            <div className="row py-4">
                <div
                className="col-lg-7 appear-animation animated fadeIn appear-animation-visible"
                data-appear-animation="fadeIn"
                data-appear-animation-delay={650}
                style={{ animationDelay: "650ms" }}
                >
                <form id="contact-form" onSubmit={handleSubmit} noValidate  >
                        <div className="row">
                            <div className="form-group col-md-6">
                                <label className="form-label mb-1 text-2">Name</label>
                                <input
                                    type="text"
                                    className="form-control text-3 h-auto py-2"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    />
                                {errors.name && <span className="error">{errors.name}</span>}
                            </div>
                            <div className="form-group col-md-6">
                                <label className="form-label mb-1 text-2">Email</label>
                                <input
                                    type="email"
                                    className="form-control text-3 h-auto py-2"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    />
                                {errors.email && <span className="error">{errors.email}</span>}
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group col-md-12 mb-4">
                                <label className="form-label mb-1 text-2">Message</label>
                                <textarea
                                    className="form-control text-3 h-auto py-2"
                                    name="message"
                                    rows="6"
                                    value={formData.message}
                                    onChange={handleChange}
                                    />
                                {errors.message && <span className="error">{errors.message}</span>}
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group col-md-12 mb-5">
                                <button type="submit" className="btn btn-primary btn-modern pull-right" disabled={isSubmitting}>
                                {isSubmitting ? 'Sending...' : 'Send Message'}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="col-lg-5">
                    <div className="overflow-hidden mb-1">
                        <h4
                        className="text-primary mb-0 appear-animation animated maskUp appear-animation-visible"
                        data-appear-animation="maskUp"
                        data-appear-animation-delay={200}
                        style={{ animationDelay: "200ms" }}
                        >
                        <span  dangerouslySetInnerHTML={{ __html: props?.setting?.contact_us_get_in_touch_title }}></span>
                        </h4>
                    </div>
                    <div className="overflow-hidden">
                        <p
                        className="mb-0 appear-animation animated maskUp appear-animation-visible"
                        data-appear-animation="maskUp"
                        data-appear-animation-delay={600}
                        style={{ animationDelay: "600ms" }}
                        >
                        <span  dangerouslySetInnerHTML={{ __html: props?.setting?.contact_us_get_in_touch_description }}></span>
                        </p>
                    </div>
                    <div
                    className="appear-animation animated fadeInUpShorter appear-animation-visible"
                    data-appear-animation="fadeInUpShorter"
                    data-appear-animation-delay={800}
                    style={{ animationDelay: "800ms" }}
                    >
                    <h4 className="text-primary pt-5">
                        Our <strong>Office</strong>
                    </h4>
                    <ul className="list list-icons list-icons-style-3 mt-2">
                        <li>
                            <i className="fas fa-map-marker-alt top-6" />{" "}
                            <strong>Address:</strong> <span className="text-4 mb-0" dangerouslySetInnerHTML={{ __html: props?.setting?.footer_adderss }}></span>
                        </li>
                        <li>
                            <i className="fas fa-phone top-6" /> <strong>Phone:</strong> <span>{props?.setting?.phone}</span>
                        </li>
                        <li>
                            <i className="fas fa-envelope top-6" /> <strong>Email:</strong>{" "}
                            <a href="mailto:mail@example.com">mail@example.com</a>
                        </li>
                    </ul>
                    <h4 className="text-primary pt-5">
                        Business <strong>Hours</strong>
                    </h4>
                    <ul className="list list-icons list-dark mt-2">

                        {props?.setting?.footer_opening_hours?.map((record, index) => (
                        <li key={index}>
                            <i className="far fa-clock top-6" /> {record.title} - {record.description}
                        </li>
                        ))}

                    </ul>
                </div>
            </div>
        </div>
        </div>
        <div className="google__map" style={{ height: '550px'}}  dangerouslySetInnerHTML={{ __html: props?.setting?.contact_us_get_in_touch_map }} ></div>
    </React.Fragment>
    );
};

export default ContactForm;
